export const actionType = {
  submit: "submit",
  next: "next",
};

export const actionResultType = {
  REDIRECT: "REDIRECT",
};
